import type { DriveStep } from 'driver.js';

export const posOrdersTour: DriveStep[] = [
  {
    element: '[data-tour="dept-tabs"]',
    popover: {
      title: 'Department Tabs',
      description:
        'Filter the display by kitchen department — All, Food, Beverage, Merchandise, or Service. Each tab shows the number of items waiting in that department.',
      side: 'top',
      align: 'center',
    },
  },
  {
    element: '[data-tour="livestatus-chip"]',
    popover: {
      title: 'Live Updates',
      description:
        'This display updates in real-time via WebSocket. "Live" means you are connected. "Polling" means the connection dropped and the page is checking for updates every few seconds.',
      side: 'bottom',
      align: 'start',
    },
  },
  {
    element: '[data-tour="kanban-columns"]',
    popover: {
      title: 'Kanban Board',
      description:
        'Orders are shown as cards moving through four columns — Pending, In Progress, Ready, and Served. The kitchen staff advances each item through the workflow.',
      side: 'top',
      align: 'start',
    },
  },
  {
    element: '[data-tour="item-actions"]',
    popover: {
      title: 'Item Actions',
      description:
        'Each card has action buttons at the bottom. Drag a card between columns, or click the buttons to quickly change its status. The available actions depend on the current column.',
      side: 'bottom',
      align: 'start',
    },
  },
  {
    popover: {
      title: 'Workflow Lifecycle',
      description:
        'Items flow: <b>Pending</b> → <b>In Progress</b> (kitchen starts cooking) → <b>Ready</b> (done cooking) → <b>Served</b> (delivered to guest). Cancel is available at any stage.',
      side: 'bottom',
      align: 'center',
    },
  },
];
